
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.7.0
 * Query Engine version: 3cff47a7f5d65c3ea74883f1d736e41d68ce91ed
 */
Prisma.prismaVersion = {
  client: "6.7.0",
  engine: "3cff47a7f5d65c3ea74883f1d736e41d68ce91ed"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AdminScalarFieldEnum = {
  id: 'id',
  role: 'role',
  permissions: 'permissions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BillingScalarFieldEnum = {
  id: 'id',
  externalID: 'externalID',
  talentProfileId: 'talentProfileId',
  jobAssignmentId: 'jobAssignmentId',
  createdById: 'createdById',
  amount: 'amount',
  message: 'message',
  salesAmount: 'salesAmount',
  currency: 'currency',
  year: 'year',
  month: 'month',
  status: 'status',
  dueDate: 'dueDate',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BillingLineItemScalarFieldEnum = {
  id: 'id',
  description: 'description',
  amount: 'amount',
  unit: 'unit',
  quantity: 'quantity',
  price: 'price',
  currency: 'currency',
  billingId: 'billingId',
  createdById: 'createdById',
  attachments: 'attachments',
  createdAt: 'createdAt'
};

exports.Prisma.CompanyScalarFieldEnum = {
  id: 'id',
  shortId: 'shortId',
  scraped: 'scraped',
  plan: 'plan',
  name: 'name',
  description: 'description',
  scrapedDescription: 'scrapedDescription',
  address: 'address',
  country: 'country',
  city: 'city',
  location: 'location',
  website: 'website',
  industry: 'industry',
  size: 'size',
  type: 'type',
  logo: 'logo',
  linkedin: 'linkedin',
  twitter: 'twitter',
  youtube: 'youtube',
  facebook: 'facebook',
  github: 'github',
  discord: 'discord',
  email: 'email',
  phone: 'phone',
  product: 'product',
  contactInfo: 'contactInfo',
  isPossibleDuplicate: 'isPossibleDuplicate',
  verificationStatus: 'verificationStatus',
  accountingCurrency: 'accountingCurrency',
  enrichmentStatus: 'enrichmentStatus',
  enrichmentFailedAt: 'enrichmentFailedAt',
  enrichedAt: 'enrichedAt',
  relatedComputedAt: 'relatedComputedAt',
  scrapedAt: 'scrapedAt',
  moderatedAt: 'moderatedAt',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyClaimRequestScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  userId: 'userId',
  method: 'method',
  status: 'status',
  dnsToken: 'dnsToken',
  verifiedAt: 'verifiedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyCreditScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  amount: 'amount',
  currency: 'currency',
  until: 'until',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyDefaultPermissionsScalarFieldEnum = {
  id: 'id',
  permissions: 'permissions',
  role: 'role'
};

exports.Prisma.CompanyHiringStepScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  stepName: 'stepName',
  stepDescription: 'stepDescription',
  order: 'order',
  group: 'group',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyInvoiceDetailScalarFieldEnum = {
  id: 'id',
  talentId: 'talentId',
  companyId: 'companyId',
  details: 'details',
  currency: 'currency',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyMemberInvitationScalarFieldEnum = {
  id: 'id',
  token: 'token',
  email: 'email',
  companyId: 'companyId',
  roleId: 'roleId',
  invitedById: 'invitedById',
  acceptedAt: 'acceptedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyOnProviderCompanyScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  providerCompanyId: 'providerCompanyId'
};

exports.Prisma.CompanyOnUserScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  userId: 'userId',
  roleId: 'roleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyPermissionsScalarFieldEnum = {
  id: 'id',
  permissions: 'permissions',
  companyId: 'companyId'
};

exports.Prisma.CompanyRoleScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  defaultPermissionsId: 'defaultPermissionsId',
  role: 'role',
  permissions: 'permissions',
  isDefault: 'isDefault'
};

exports.Prisma.CompanySavedTalentScalarFieldEnum = {
  id: 'id',
  talentProfileId: 'talentProfileId',
  companyId: 'companyId',
  userId: 'userId',
  companySavedTalentListId: 'companySavedTalentListId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CompanySavedTalentListScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  label: 'label',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CompanyTalentNoteScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  talentProfileId: 'talentProfileId',
  userId: 'userId',
  note: 'note',
  private: 'private',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyTalentRosterScalarFieldEnum = {
  id: 'id',
  externalID: 'externalID',
  talentProfileId: 'talentProfileId',
  managerId: 'managerId',
  companyId: 'companyId',
  balance: 'balance',
  currency: 'currency',
  employmentType: 'employmentType',
  employeeNumber: 'employeeNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FeatureFlagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserFeatureFlagScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  featureFlagId: 'featureFlagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.IdpScalarFieldEnum = {
  id: 'id',
  email: 'email',
  slug: 'slug',
  config: 'config',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  externalID: 'externalID',
  createdById: 'createdById',
  fromCompanyId: 'fromCompanyId',
  toCompanyId: 'toCompanyId',
  jobAssignmentId: 'jobAssignmentId',
  talentProfileId: 'talentProfileId',
  billingId: 'billingId',
  total: 'total',
  currency: 'currency',
  description: 'description',
  status: 'status',
  invoiceDetails: 'invoiceDetails',
  dueDate: 'dueDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobAdScalarFieldEnum = {
  id: 'id',
  shortId: 'shortId',
  scraped: 'scraped',
  jobDescriptionId: 'jobDescriptionId',
  publisherCompanyId: 'publisherCompanyId',
  ownerUserId: 'ownerUserId',
  postedByEmail: 'postedByEmail',
  externalId: 'externalId',
  source: 'source',
  slug: 'slug',
  url: 'url',
  originalJobPostUrl: 'originalJobPostUrl',
  ogImageUrl: 'ogImageUrl',
  title: 'title',
  description: 'description',
  scrapedDescription: 'scrapedDescription',
  shortParaphrasedDescription: 'shortParaphrasedDescription',
  paraphrasedDescription: 'paraphrasedDescription',
  adDescription: 'adDescription',
  location: 'location',
  country: 'country',
  city: 'city',
  salary: 'salary',
  currency: 'currency',
  language: 'language',
  scrapedLanguage: 'scrapedLanguage',
  employmentType: 'employmentType',
  scrapedEmploymentType: 'scrapedEmploymentType',
  workMode: 'workMode',
  remoteType: 'remoteType',
  assignmentType: 'assignmentType',
  department: 'department',
  isTechnical: 'isTechnical',
  roleCategory: 'roleCategory',
  blocksRecruitmentAgencies: 'blocksRecruitmentAgencies',
  isAnonymous: 'isAnonymous',
  skills: 'skills',
  skills_lowercase: 'skills_lowercase',
  keywords: 'keywords',
  suggestedSkills: 'suggestedSkills',
  info: 'info',
  globalScore: 'globalScore',
  embeddingGeneratedAt: 'embeddingGeneratedAt',
  enrichmentStatus: 'enrichmentStatus',
  enrichmentFailedAt: 'enrichmentFailedAt',
  relatedComputedAt: 'relatedComputedAt',
  postedAt: 'postedAt',
  scrapedAt: 'scrapedAt',
  enrichedAt: 'enrichedAt',
  matchedAt: 'matchedAt',
  moderatedAt: 'moderatedAt',
  publishedAt: 'publishedAt',
  publishedUntil: 'publishedUntil',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  seniority: 'seniority',
  minYearsExperience: 'minYearsExperience',
  salaryMin: 'salaryMin',
  salaryMax: 'salaryMax',
  salaryCurrency: 'salaryCurrency',
  salaryFrequency: 'salaryFrequency',
  visaSponsorship: 'visaSponsorship'
};

exports.Prisma.JobAdViewScalarFieldEnum = {
  id: 'id',
  jobAdId: 'jobAdId',
  count: 'count',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobAdBoostScalarFieldEnum = {
  id: 'id',
  jobAdId: 'jobAdId',
  boostedUntil: 'boostedUntil',
  createdAt: 'createdAt'
};

exports.Prisma.JobAssignmentScalarFieldEnum = {
  id: 'id',
  jobDescriptionId: 'jobDescriptionId',
  talentProfileId: 'talentProfileId',
  salesCompanyId: 'salesCompanyId',
  providerCompanyId: 'providerCompanyId',
  clientCompanyId: 'clientCompanyId',
  clientPricesIsVisibleToTalent: 'clientPricesIsVisibleToTalent',
  assignmentCurrency: 'assignmentCurrency',
  team: 'team',
  costCenter: 'costCenter',
  talentNote: 'talentNote',
  startDate: 'startDate',
  endDate: 'endDate',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobDescriptionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  location: 'location',
  skills: 'skills',
  skills_lowercase: 'skills_lowercase',
  salary: 'salary',
  currency: 'currency',
  language: 'language',
  openForApplications: 'openForApplications',
  workMode: 'workMode',
  assignmentType: 'assignmentType',
  clientCompanyId: 'clientCompanyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LanguagesListScalarFieldEnum = {
  id: 'id',
  label: 'label',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.Blog_postScalarFieldEnum = {
  id: 'id',
  title: 'title',
  slug: 'slug',
  metaDescription: 'metaDescription',
  content: 'content',
  excerpt: 'excerpt',
  category: 'category',
  author: 'author',
  canonicalUrl: 'canonicalUrl',
  featured: 'featured',
  keywords: 'keywords',
  faqData: 'faqData',
  targetKeyword: 'targetKeyword',
  h1: 'h1',
  sourceNewsUrl: 'sourceNewsUrl',
  sourceNewsTitle: 'sourceNewsTitle',
  supplementarySourceUrls: 'supplementarySourceUrls',
  supplementarySourceTitles: 'supplementarySourceTitles',
  skipReason: 'skipReason',
  reangleHint: 'reangleHint',
  similarPostId: 'similarPostId',
  relatedComputedAt: 'relatedComputedAt',
  embeddingGeneratedAt: 'embeddingGeneratedAt',
  processingStartedAt: 'processingStartedAt',
  preProcessingStatus: 'preProcessingStatus',
  qualityScore: 'qualityScore',
  newsRelevanceScore: 'newsRelevanceScore',
  status: 'status',
  failureReason: 'failureReason',
  rescueAttempts: 'rescueAttempts',
  lastRescueAt: 'lastRescueAt',
  readingTimeMinutes: 'readingTimeMinutes',
  wordCount: 'wordCount',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.Blog_tagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug'
};

exports.Prisma.Blog_post_tagScalarFieldEnum = {
  blogPostId: 'blogPostId',
  tagId: 'tagId',
  createdAt: 'createdAt'
};

exports.Prisma.Blog_post_imageScalarFieldEnum = {
  id: 'id',
  blogPostId: 'blogPostId',
  url: 'url',
  urlAvif: 'urlAvif',
  alt: 'alt',
  caption: 'caption',
  title: 'title',
  role: 'role',
  position: 'position',
  width: 'width',
  height: 'height',
  format: 'format',
  sizeBytes: 'sizeBytes',
  prompt: 'prompt',
  model: 'model',
  createdAt: 'createdAt'
};

exports.Prisma.Blog_post_factScalarFieldEnum = {
  id: 'id',
  blogPostId: 'blogPostId',
  statement: 'statement',
  type: 'type',
  source: 'source',
  sourceExcerpt: 'sourceExcerpt',
  verbatimText: 'verbatimText',
  attribution: 'attribution',
  createdAt: 'createdAt'
};

exports.Prisma.Social_postScalarFieldEnum = {
  id: 'id',
  channel: 'channel',
  entityType: 'entityType',
  entityId: 'entityId',
  messageId: 'messageId',
  status: 'status',
  error: 'error',
  attemptCount: 'attemptCount',
  postedAt: 'postedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.Blog_post_related_postScalarFieldEnum = {
  blogPostId: 'blogPostId',
  relatedPostId: 'relatedPostId',
  position: 'position',
  similarity: 'similarity'
};

exports.Prisma.Blog_post_related_jobScalarFieldEnum = {
  blogPostId: 'blogPostId',
  jobAdId: 'jobAdId',
  position: 'position',
  similarity: 'similarity'
};

exports.Prisma.Job_related_blog_postScalarFieldEnum = {
  jobAdId: 'jobAdId',
  blogPostId: 'blogPostId',
  position: 'position',
  similarity: 'similarity'
};

exports.Prisma.Job_related_jobScalarFieldEnum = {
  jobAdId: 'jobAdId',
  relatedJobAdId: 'relatedJobAdId',
  position: 'position',
  similarity: 'similarity'
};

exports.Prisma.Company_related_blog_postScalarFieldEnum = {
  companyId: 'companyId',
  blogPostId: 'blogPostId',
  position: 'position',
  similarity: 'similarity'
};

exports.Prisma.CampaignScalarFieldEnum = {
  id: 'id',
  talentProfileId: 'talentProfileId',
  subject: 'subject',
  avg_match_score: 'avg_match_score',
  min_match_score: 'min_match_score',
  max_match_score: 'max_match_score',
  template_variant: 'template_variant',
  created_at: 'created_at',
  sent_at: 'sent_at',
  approved_at: 'approved_at',
  rejected_at: 'rejected_at',
  rejection_reason: 'rejection_reason',
  status: 'status'
};

exports.Prisma.Campaign_approval_metricsScalarFieldEnum = {
  id: 'id',
  date: 'date',
  min_score_used: 'min_score_used',
  campaigns_generated: 'campaigns_generated',
  campaigns_approved: 'campaigns_approved',
  campaigns_rejected: 'campaigns_rejected',
  avg_approved_score: 'avg_approved_score',
  avg_rejected_score: 'avg_rejected_score',
  approval_rate: 'approval_rate',
  calculated_at: 'calculated_at'
};

exports.Prisma.Campaign_clickScalarFieldEnum = {
  id: 'id',
  campaign_id: 'campaign_id',
  jobAdId: 'jobAdId',
  talentProfileId: 'talentProfileId',
  position: 'position',
  variant: 'variant',
  clicked_at: 'clicked_at',
  user_agent: 'user_agent',
  referrer: 'referrer',
  interest: 'interest',
  interest_at: 'interest_at',
  signature_valid: 'signature_valid'
};

exports.Prisma.Campaign_email_eventScalarFieldEnum = {
  id: 'id',
  campaign_id: 'campaign_id',
  talentProfileId: 'talentProfileId',
  event_type: 'event_type',
  mailgun_id: 'mailgun_id',
  recipient: 'recipient',
  timestamp: 'timestamp',
  url: 'url',
  severity: 'severity',
  reason: 'reason',
  delivery_status: 'delivery_status',
  complaint_type: 'complaint_type',
  raw_event: 'raw_event',
  signature_valid: 'signature_valid',
  created_at: 'created_at'
};

exports.Prisma.Campaign_jobScalarFieldEnum = {
  id: 'id',
  campaign_id: 'campaign_id',
  jobAdId: 'jobAdId',
  match_score: 'match_score',
  match_score_details: 'match_score_details',
  matched_keywords: 'matched_keywords',
  position: 'position',
  llm_verified_score: 'llm_verified_score',
  llm_reasoning: 'llm_reasoning',
  moderator_score: 'moderator_score',
  moderator_notes: 'moderator_notes',
  created_at: 'created_at'
};

exports.Prisma.Form_analytics_eventScalarFieldEnum = {
  id: 'id',
  form_id: 'form_id',
  event_type: 'event_type',
  field_name: 'field_name',
  error_message: 'error_message',
  session_id: 'session_id',
  user_agent: 'user_agent',
  ip_address: 'ip_address',
  created_at: 'created_at'
};

exports.Prisma.Form_analytics_summaryScalarFieldEnum = {
  id: 'id',
  form_id: 'form_id',
  date: 'date',
  sessions_started: 'sessions_started',
  sessions_completed: 'sessions_completed',
  completion_rate: 'completion_rate',
  avg_time_to_complete: 'avg_time_to_complete',
  field_errors: 'field_errors',
  calculated_at: 'calculated_at'
};

exports.Prisma.GeneralEventslogScalarFieldEnum = {
  id: 'id',
  type: 'type',
  eventData: 'eventData',
  createdAt: 'createdAt'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  fromId: 'fromId',
  toId: 'toId',
  eventId: 'eventId',
  createdAt: 'createdAt',
  readAt: 'readAt'
};

exports.Prisma.SavedJobAdScalarFieldEnum = {
  id: 'id',
  jobAdId: 'jobAdId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.SkillQuizScalarFieldEnum = {
  id: 'id',
  skillId: 'skillId',
  difficulty: 'difficulty',
  questions: 'questions',
  questionCount: 'questionCount',
  generatedBy: 'generatedBy',
  version: 'version',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SkillQuizAttemptScalarFieldEnum = {
  id: 'id',
  quizId: 'quizId',
  talentProfileId: 'talentProfileId',
  questionIndices: 'questionIndices',
  answers: 'answers',
  score: 'score',
  totalQuestions: 'totalQuestions',
  correctCount: 'correctCount',
  timeSpentSeconds: 'timeSpentSeconds',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  createdAt: 'createdAt'
};

exports.Prisma.SkillsListScalarFieldEnum = {
  id: 'id',
  department: 'department',
  label: 'label',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentBalanceTransactionScalarFieldEnum = {
  id: 'id',
  companyTalentRosterId: 'companyTalentRosterId',
  change: 'change',
  currency: 'currency',
  companyId: 'companyId',
  jobAssignmentId: 'jobAssignmentId',
  createdById: 'createdById',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentInvitationScalarFieldEnum = {
  id: 'id',
  jobAdId: 'jobAdId',
  jobDescriptionId: 'jobDescriptionId',
  talentProfileId: 'talentProfileId',
  invitedByUserId: 'invitedByUserId',
  companyId: 'companyId',
  details: 'details',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  ignoredAt: 'ignoredAt',
  ignored: 'ignored'
};

exports.Prisma.TalentJobApplicationScalarFieldEnum = {
  id: 'id',
  jobAdId: 'jobAdId',
  jobDescriptionId: 'jobDescriptionId',
  talentProfileId: 'talentProfileId',
  externalJobId: 'externalJobId',
  assigneeUserId: 'assigneeUserId',
  details: 'details',
  message: 'message',
  companyHiringStepId: 'companyHiringStepId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  viewedAt: 'viewedAt'
};

exports.Prisma.TalentPaymentProfileScalarFieldEnum = {
  id: 'id',
  talentProfileId: 'talentProfileId',
  currency: 'currency',
  bankInformation: 'bankInformation',
  isVerified: 'isVerified',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentProfileScalarFieldEnum = {
  id: 'id',
  shortId: 'shortId',
  scraped: 'scraped',
  source: 'source',
  externalId: 'externalId',
  username: 'username',
  externalUserId: 'externalUserId',
  email: 'email',
  profileName: 'profileName',
  phoneNumber: 'phoneNumber',
  identificationToken: 'identificationToken',
  profilePicture: 'profilePicture',
  jobTitle: 'jobTitle',
  totalExperience: 'totalExperience',
  description: 'description',
  isVisible: 'isVisible',
  isAvailableForHire: 'isAvailableForHire',
  workMode: 'workMode',
  availabilityMode: 'availabilityMode',
  contractTypes: 'contractTypes',
  assignmentType: 'assignmentType',
  location: 'location',
  interestedToRelocateTo: 'interestedToRelocateTo',
  isInterestedInRelocation: 'isInterestedInRelocation',
  hourlyRate: 'hourlyRate',
  monthlyRate: 'monthlyRate',
  minimumHourlyRate: 'minimumHourlyRate',
  minimumMonthlyRate: 'minimumMonthlyRate',
  targetHourlyRate: 'targetHourlyRate',
  targetMonthlyRate: 'targetMonthlyRate',
  rateCurrency: 'rateCurrency',
  skills: 'skills',
  skills_lowercase: 'skills_lowercase',
  links: 'links',
  links_temp: 'links_temp',
  languages: 'languages',
  resume: 'resume',
  pdf: 'pdf',
  cv: 'cv',
  experience: 'experience',
  certification: 'certification',
  education: 'education',
  roleCategory: 'roleCategory',
  scrapedMeta: 'scrapedMeta',
  verificationStatus: 'verificationStatus',
  preference_token: 'preference_token',
  email_frequency: 'email_frequency',
  email_unsubscribed: 'email_unsubscribed',
  embeddingGeneratedAt: 'embeddingGeneratedAt',
  userId: 'userId',
  scrapedAt: 'scrapedAt',
  enrichedAt: 'enrichedAt',
  moderatedAt: 'moderatedAt',
  matchedAt: 'matchedAt',
  lastContactedAt: 'lastContactedAt',
  personalizedJobsFoundAt: 'personalizedJobsFoundAt',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentProfileBoostScalarFieldEnum = {
  id: 'id',
  talentProfileId: 'talentProfileId',
  boostedUntil: 'boostedUntil',
  createdAt: 'createdAt'
};

exports.Prisma.TalentJobAdViewScalarFieldEnum = {
  id: 'id',
  talentProfileId: 'talentProfileId',
  jobAdId: 'jobAdId',
  source: 'source',
  campaign_id: 'campaign_id',
  viewed_at: 'viewed_at'
};

exports.Prisma.TalentProfileViewScalarFieldEnum = {
  id: 'id',
  talentProfileId: 'talentProfileId',
  companyId: 'companyId',
  userId: 'userId',
  viewedAt: 'viewedAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  externalId: 'externalId',
  secondaryExternalId: 'secondaryExternalId',
  passwordHash: 'passwordHash',
  ipdId: 'ipdId',
  redirect: 'redirect',
  preferences: 'preferences',
  displayName: 'displayName',
  phoneNumber: 'phoneNumber',
  adminRoleId: 'adminRoleId',
  status: 'status',
  emailVerifiedAt: 'emailVerifiedAt',
  isOnline: 'isOnline',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastVisit: 'lastVisit'
};

exports.Prisma.RefreshTokenScalarFieldEnum = {
  id: 'id',
  hashedToken: 'hashedToken',
  userId: 'userId',
  expiresAt: 'expiresAt',
  idleExpiresAt: 'idleExpiresAt',
  usedAt: 'usedAt',
  createdAt: 'createdAt'
};

exports.Prisma.EmailVerificationTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  createdAt: 'createdAt'
};

exports.Prisma.MagicLinkTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  createdAt: 'createdAt'
};

exports.Prisma.PasswordResetTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  createdAt: 'createdAt'
};

exports.Prisma.UserNotificationPreferencesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  email: 'email',
  ui: 'ui',
  push: 'push',
  type: 'type'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.BILLING_STATUS = exports.$Enums.BILLING_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  APPROVED: 'APPROVED',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  REJECTED: 'REJECTED'
};

exports.RATE_UNIT = exports.$Enums.RATE_UNIT = {
  HOUR: 'HOUR',
  DAY: 'DAY',
  MONTH: 'MONTH'
};

exports.COMPANY_PLAN = exports.$Enums.COMPANY_PLAN = {
  BASIC: 'BASIC',
  ENTERPRISE: 'ENTERPRISE'
};

exports.VERIFICATION_STATUS = exports.$Enums.VERIFICATION_STATUS = {
  verified: 'verified',
  pending: 'pending',
  rejected: 'rejected',
  deleted: 'deleted'
};

exports.EMPLOYMENT_TYPE = exports.$Enums.EMPLOYMENT_TYPE = {
  freelancer: 'freelancer',
  employee: 'employee'
};

exports.INVOICE_STATUS = exports.$Enums.INVOICE_STATUS = {
  PAID: 'PAID',
  UNPAID: 'UNPAID'
};

exports.WORK_MODE = exports.$Enums.WORK_MODE = {
  remote: 'remote',
  hybrid: 'hybrid',
  onsite: 'onsite'
};

exports.ASSIGNMENT_TYPE = exports.$Enums.ASSIGNMENT_TYPE = {
  fulltime: 'fulltime',
  parttime: 'parttime',
  ondemand: 'ondemand'
};

exports.QUIZ_DIFFICULTY = exports.$Enums.QUIZ_DIFFICULTY = {
  beginner: 'beginner',
  intermediate: 'intermediate',
  advanced: 'advanced'
};

exports.SKILL_QUIZ_STATUS = exports.$Enums.SKILL_QUIZ_STATUS = {
  pending: 'pending',
  active: 'active',
  inactive: 'inactive',
  error: 'error'
};

exports.SKILL_QUIZ_ATTEMPT_STATUS = exports.$Enums.SKILL_QUIZ_ATTEMPT_STATUS = {
  in_progress: 'in_progress',
  completed: 'completed',
  expired: 'expired',
  abandoned: 'abandoned'
};

exports.TRANSACTION_TYPES = exports.$Enums.TRANSACTION_TYPES = {
  SALARY: 'SALARY',
  COMISSION: 'COMISSION',
  MISC: 'MISC',
  WITHDRAWAL: 'WITHDRAWAL'
};

exports.USER_STATUS = exports.$Enums.USER_STATUS = {
  deleted: 'deleted',
  blocked: 'blocked',
  active: 'active'
};

exports.Prisma.ModelName = {
  admin: 'admin',
  billing: 'billing',
  billingLineItem: 'billingLineItem',
  company: 'company',
  companyClaimRequest: 'companyClaimRequest',
  companyCredit: 'companyCredit',
  companyDefaultPermissions: 'companyDefaultPermissions',
  companyHiringStep: 'companyHiringStep',
  companyInvoiceDetail: 'companyInvoiceDetail',
  companyMemberInvitation: 'companyMemberInvitation',
  companyOnProviderCompany: 'companyOnProviderCompany',
  companyOnUser: 'companyOnUser',
  companyPermissions: 'companyPermissions',
  companyRole: 'companyRole',
  companySavedTalent: 'companySavedTalent',
  companySavedTalentList: 'companySavedTalentList',
  companyTalentNote: 'companyTalentNote',
  companyTalentRoster: 'companyTalentRoster',
  featureFlag: 'featureFlag',
  userFeatureFlag: 'userFeatureFlag',
  idp: 'idp',
  invoice: 'invoice',
  jobAd: 'jobAd',
  jobAdView: 'jobAdView',
  jobAdBoost: 'jobAdBoost',
  jobAssignment: 'jobAssignment',
  jobDescription: 'jobDescription',
  languagesList: 'languagesList',
  blog_post: 'blog_post',
  blog_tag: 'blog_tag',
  blog_post_tag: 'blog_post_tag',
  blog_post_image: 'blog_post_image',
  blog_post_fact: 'blog_post_fact',
  social_post: 'social_post',
  blog_post_related_post: 'blog_post_related_post',
  blog_post_related_job: 'blog_post_related_job',
  job_related_blog_post: 'job_related_blog_post',
  job_related_job: 'job_related_job',
  company_related_blog_post: 'company_related_blog_post',
  campaign: 'campaign',
  campaign_approval_metrics: 'campaign_approval_metrics',
  campaign_click: 'campaign_click',
  campaign_email_event: 'campaign_email_event',
  campaign_job: 'campaign_job',
  form_analytics_event: 'form_analytics_event',
  form_analytics_summary: 'form_analytics_summary',
  generalEventslog: 'generalEventslog',
  notification: 'notification',
  savedJobAd: 'savedJobAd',
  skillQuiz: 'skillQuiz',
  skillQuizAttempt: 'skillQuizAttempt',
  skillsList: 'skillsList',
  talentBalanceTransaction: 'talentBalanceTransaction',
  talentInvitation: 'talentInvitation',
  talentJobApplication: 'talentJobApplication',
  talentPaymentProfile: 'talentPaymentProfile',
  talentProfile: 'talentProfile',
  talentProfileBoost: 'talentProfileBoost',
  talentJobAdView: 'talentJobAdView',
  talentProfileView: 'talentProfileView',
  user: 'user',
  refreshToken: 'refreshToken',
  emailVerificationToken: 'emailVerificationToken',
  magicLinkToken: 'magicLinkToken',
  passwordResetToken: 'passwordResetToken',
  userNotificationPreferences: 'userNotificationPreferences'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
